import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Empty, Rows } from "@/components/ui-helpers";
import { fmtDateTime } from "@/lib/fmt";
import { ExternalLink, RefreshCw } from "lucide-react";

export default function LeadCalls({ leadId }) {
  const [d, setD] = useState(null);
  const load = (refresh) => { setD(null); api.get(`/crm/leads/${leadId}/calls`, { params: { refresh }, timeout: 60000 }).then((r) => setD(r.data)).catch(() => setD({ rows: [], sources: [], note: "Could not reach Fathom" })); };
  useEffect(() => { load(false); }, [leadId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return <Rows n={3} />;
  return (
    <div className="space-y-3" data-testid="lead-calls">
      <div className="flex items-center text-xs text-neutral-500">
        <span className="flex-1">{d.sources.length ? `Fathom: ${d.sources.join(", ")}` : "No Fathom account connected. Add your key in Settings."}{d.note ? ` · ${d.note}` : ""}</span>
        <button className="btn text-xs" onClick={() => load(true)} data-testid="lead-calls-refresh"><RefreshCw size={12} />Refresh</button>
      </div>
      {!d.rows.length ? <Empty label="No recorded calls with this lead" /> : d.rows.map((c) => (
        <div key={c.recording_id} className="panel p-3 space-y-1.5" data-testid={`call-${c.recording_id}`}>
          <div className="flex items-center gap-2 text-sm"><span className="font-medium flex-1 break-words">{c.title || "Call"}</span><span className="text-xs text-neutral-500">{fmtDateTime(c.at)}</span>
            {(c.share_url || c.url) && <a className="btn text-xs" href={c.share_url || c.url} target="_blank" rel="noreferrer" data-testid={`call-link-${c.recording_id}`}><ExternalLink size={12} />Open</a>}</div>
          <div className="text-[11px] text-neutral-500">Recorded by {c.recorded_by}</div>
          {c.summary && <div className="text-xs text-neutral-300 whitespace-pre-wrap">{c.summary}</div>}
        </div>
      ))}
    </div>
  );
}
